import { CLIENT_API } from 'api';

export const getImageUrl = (path?: string) => {
  if (path && (path.startsWith('http') || !path.startsWith('uploads'))) return path;
  if (!path) return `${CLIENT_API}/`;

  return `${CLIENT_API}/${path}`;
};
